import { trpc } from '@/shared/api/trpc';

export const useRestoreAccount = () => {
  const utils = trpc.useUtils();
  return trpc.accounts.restore.useMutation({
    onSettled: () => {
      utils.accounts.listAllowlist.invalidate();
      utils.accounts.list.invalidate();
      utils.accounts.listForFilters.invalidate();
    },
  });
};
